var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;fill:url(#D\xE9grad\xE9_sans_nom_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    y1: 32,
    x2: 64,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8452a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b5ca8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,48.82A16,16,0,0,1,48,64H34a2,2,0,0,1,0-4H48A12,12,0,0,0,60,48V34a6,6,0,0,0-6-6H49a6,6,0,0,1-5.69-7.91A11.86,11.86,0,0,0,44,16V8a4,4,0,0,0-8,0v3c0,3.88-4.19,8.51-8.5,12.81a41.89,41.89,0,0,1-4.39,3.68A7.48,7.48,0,0,0,20,33.56V55a4.9,4.9,0,0,1-.31,1.67,4.76,4.76,0,0,1-.29.65.93.93,0,0,1,0,.1A4.28,4.28,0,0,1,19,58l-.05.07a4.53,4.53,0,0,1-.88.87,1.07,1.07,0,0,1-.16.14l-.37.22-.41.23-.35.14a5.05,5.05,0,0,1-.55.18l-.3.07A5.4,5.4,0,0,1,15,60H8a8,8,0,0,1-8-8V32a8,8,0,0,1,8-8h2a2,2,0,0,1,0,4H8a4,4,0,0,0-4,4V52a4,4,0,0,0,4,4h6a2,2,0,0,0,2-2V33.56a11.45,11.45,0,0,1,4.57-9.17C26.11,20.3,32,14.6,32,8A8,8,0,0,1,48,8v9a15.65,15.65,0,0,1-.9,5h0a1.32,1.32,0,0,0-.1.53A1.5,1.5,0,0,0,48.5,24H56a8,8,0,0,1,8,8V48a7.38,7.38,0,0,1,0,.82ZM26,56a2,2,0,1,1-2,2,2,2,0,0,1,2-2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.637590f525315eefd584245a3ac6a131.svg";
export { ForwardRef as ReactComponent };